<template>
    <div class="ion-page">
        <div>
            <ion-grid fixed>
                <ion-row class="rectangle">
                    <ion-col>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="2">
                                <ion-label class="section-head">Select Dashboard</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-select
                                        class="form-select select-mobile"
                                        :value="chartName"
                                        @ionChange="selectDashboardChart($event)"
                                        placeholder="Select Dashboard"
                                        interface="action-sheet"
                                    >
                                        <ion-select-option
                                        v-for="(chart, index) in this.chartTypes"
                                        :key="index"
                                        :value="chart.name"
                                        >{{chart.name}}</ion-select-option>
                                    </ion-select>

                                    <select
                                        @change="selectDashboardChart($event)"
                                        class="input-select select-web"
                                        v-model="chartName"
                                        placeholder="Select Status"
                                    >
                                        <option
                                        v-for="(chart, index) in this.chartTypes"
                                        :key="index"
                                        :value="chart.name"
                                        >{{ chart.name }}</option>
                                    </select>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="2">
                                <ion-label class="section-head">Select Station</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-select
                                        class="form-select select-mobile"
                                        :value="stationName"
                                        @ionChange="selectStation($event)"
                                        placeholder="Select Dashboard"
                                        interface="action-sheet"
                                    >
                                        <ion-select-option
                                        v-for="(data, index) in stationsList.stationDetails"
                                        :key="index"
                                        :value="data.name"
                                        >{{data.name}}</ion-select-option>
                                    </ion-select>

                                    <select
                                        @change="selectStation($event)"
                                        class="input-select select-web"
                                        v-model="stationName"
                                        placeholder="Select Status"
                                    >
                                        <option
                                        v-for="(data, index) in stationsList.stationDetails"
                                        :key="index"
                                        :value="data.name"
                                        >{{ data.name }}</option>
                                    </select>
                                </div>
                            </ion-col>
                            <!-- <ion-col size="12" size-md="2">
                                <ion-label>Branch ID</ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    id="branchId"
                                    @input="branchId = $event.target.value"
                                    maxlength="50"
                                    placeholder="Branch ID"
                                    :value = branchId
                                    ></ion-input>
                                </div>
                            </ion-col> -->
                            <ion-col size="12" size-md="2">
                                <br />
                                <ion-button class="btn-search margin-top-10" @click="searchBranches">Search</ion-button>
                                <ion-button class="btn-clear margin-top-10" @click="clearFields">
                                    <ion-icon :icon="refresh"></ion-icon>
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
        <div v-if="loadChargerStausChart" class="carterEnergyDashboard">
            <CarterChargerStatusDashboard :chartData="chargerStatusData"/>
        </div>
        <div v-if="loadConsumedEnergeyChart" class="carterEnergyDashboard">
            <CarterEnergyDashboard :consumeEnergyData="greenHousGasData"/>
        </div>
        <div v-if="!noStationAssociatedInd && !displayInd">
            <ion-grid>
                <ion-row class="rectangle">
                    <ion-col>
                        <p class="noAssociatedStations"  style="text-align: center;">No Associated Stations</p>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <div v-if="noDataForEnergy">
            <ion-grid>
                <ion-row class="rectangle">
                    <ion-col>
                        <p class="noStations1"  style="text-align: center;" >No data for input criteria</p>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
    </div>
</template>

<script>
import { defineComponent, render } from "vue";
import { refresh } from 'ionicons/icons';
import Chart from "chart.js/auto";
import { CorporateService } from "../../service/corporate/corporate.service";
import { flash } from 'ionicons/icons';
import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { ToastUtils } from "../../util/toast-utils";
import CarterChargerStatusDashboard from "./CarterChargerStatusDashboard.vue";
import CarterEnergyDashboard from "./CarterEnergyDashboard.vue";
import userData from "../../../public/assets/data/data.json";

export default defineComponent ({
    name: 'carterAdminDashboard',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonSelect, 
        IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner,
        CarterChargerStatusDashboard,CarterEnergyDashboard
    },
    data() {
        return {
            refresh,
            chartTypes: [{'name' : 'Charger Status'},{"name" : "Admin Dashboard"}],
            stationsList: [],
            chartName: "",
            stationName: "",
            branchId: "",
            chartTypeInd: true,
            doughnutChartInd: true,
            myChart: null,
            chargerStatusData: "",
            displayInd: false,
            loaderTab: false,
            noStationAssociatedInd: true,
            displayLineChart1: false,
            displayLineChart2: false,
            displayLineChart3: false,
            displayLineChart4: false,
            displayChargerStatus: false,
            displayFenfeoAdminChart: false,
            chargerCurrentStatusChart: null,
            dailyUsageBarChart: null,
            greenHousGasData: null,
            customerVisitCountData: null,
            transactionCountData: null,
            revenueCountData: null,
            loadChargerStausChart: false,
            loadConsumedEnergeyChart: false,
            noDataForEnergy: false
        }
    },
    async mounted() {
        this.stationsList = userData.dashboard;
        let dashboartType = localStorage.getItem('dashboardType');
        if(dashboartType == 'Charger Status') {
            this.chartName = this.chartTypes[0].name;
            // this.displayChargerStatus = true;
            localStorage.removeItem('dashboardType');
            this.loadGraphData();
        } else if(dashboartType == 'Admin Dashboard') {
            this.chartName = this.chartTypes[1].name;
            localStorage.removeItem('dashboardType');
            this.chargerCurrentStatusChart = null;
            this.displayChargerStatus = false;
            let branchInfo = JSON.parse(localStorage.getItem('branchInfoForDashboard'));
            if(branchInfo) {
                this.branchId = branchInfo.branchId;
                this.greenHousGasData = await userData.dashboard.energyconsumed;
                if(this.greenHousGasData.displayChart == true) {
                    this.displayFenfeoAdminChart = true;
                    this.displayInd = true;
                    this.loadConsumedEnergeyChart =true;  
                } else {
                    this.noDataForEnergy = true;
                }
            } else {
                this.greenHousGasData = await userData.dashboard.energyconsumed;
                if(this.greenHousGasData.displayChart == true) {
                    this.displayFenfeoAdminChart = true;
                    this.displayInd = true;
                    this.loadConsumedEnergeyChart =true;
                } else {
                    this.noDataForEnergy = true;
                }
            }
        } else {
            this.chartName = this.chartTypes[0].name;
            this.stationName = this.stationsList.stationDetails[0].name;
            this.displayChargerStatus = true
            this.loadGraphData();
        }
    },
    methods: {
        async loadGraphData() {
            if(this.$route.params.branchId == '') {
                this.branchId = this.$route.params.branchId;
                
                this.chargerStatusData = await userData.dashboard.chargerStatus;
                if(this.chargerStatusData.displayData.totalCount > 0) {
                    this.displayChargerStatus = true;
                    this.displayInd = true;
                    this.loaderTab = false;
                    this.loadChargerStausChart = true;
                } else {
                    this.noStationAssociatedInd = false;
                }
            } else {
                let branchInfo = JSON.parse(localStorage.getItem('branchInfoForDashboard'));
                let branchIDFromDashboard = localStorage.getItem('branchIDFromDashboard');
                if(branchInfo) {
                    this.branchId = branchInfo.branchId;
                    this.chargerStatusData = await userData.dashboard.chargerStatus;
                    if(this.chargerStatusData.displayData.totalCount > 0) {
                        this.loadChargerStausChart = true;
                        this.displayChargerStatus = true;
                        this.displayInd = true;
                        localStorage.removeItem('branchInfoForDashboard');
                        this.loaderTab = false;
                        
                    } else {
                        this.displayInd = false;
                        this.noStationAssociatedInd = false;
                    }
                } else if(branchIDFromDashboard) {
                    this.branchId = branchIDFromDashboard
                    this.chargerStatusData = await userData.dashboard.chargerStatus;
                    if(this.chargerStatusData.displayData.totalCount > 0) {
                        this.displayChargerStatus = true;
                        this.displayInd = true;
                        this.loaderTab = false;
                        this.loadChargerStausChart = true;
                        localStorage.removeItem('branchIDFromDashboard');
                    } else {
                        this.noStationAssociatedInd = false;
                    }
                } else {
                    this.chargerStatusData = userData.dashboard.chargerStatus;
                    if(this.chargerStatusData.displayData.totalCount > 0) {
                        this.displayChargerStatus = true;
                        this.displayInd = true;
                        this.loaderTab = false;
                        this.loadChargerStausChart = true;
                    
                    } else {
                        this.displayInd = false;
                        this.displayChargerStatus = true
                        this.noStationAssociatedInd = false;
                    }
                }
            
            }
        },

        async selectDashboardChart(event) {
            this.chartName = event.target.value;
            try {
                if(this.chartName == 'Charger Status') {
                    this.loadConsumedEnergeyChart =false;
                    this.noDataForEnergy= false;
                    this.loadGraphData();
                    
                } else if(this.chartName == 'Admin Dashboard') {
                    this.loadChargerStausChart = false;
                    this.noStationAssociatedInd = true;
                    this.greenHousGasData = await userData.dashboard.energyconsumed;
                    if(this.greenHousGasData.displayChart == true) {
                        this.displayFenfeoAdminChart = true;
                        this.displayInd = true;
                        this.loadConsumedEnergeyChart =true;
                    } else {
                        this.noDataForEnergy = true;
                    }
                    
                }
            } catch(error) {
                alert(error)
                // new ToastUtils().presentToast(error.response.data.errors[0].detail);
            }
            
        },
        async selectStation(event) {
            try {
                
                if(this.chartName == 'Charger Status') {
                    this.loadConsumedEnergeyChart =false;
                    this.noDataForEnergy= false;
                    this.loadChargerStausChart = false;
                    for(let i = 0; i <= this.stationsList.stationDetails.length; i++) {
                        if(event.target.value == this.stationsList["stationDetails"][i].name) {
                            this.chargerStatusData = await this.stationsList["stationDetails"][i].chrtInfo;
                            
                            if(this.chargerStatusData.displayData.totalCount > 0) {
                                this.displayChargerStatus = true;
                                this.displayInd = true;
                                this.loadChargerStausChart = true;
                                break;
                            } else {
                                this.noStationAssociatedInd = false;
                            }
                        }
                    }
                }  else if(this.chartName == 'Admin Dashboard') {
                    this.loadConsumedEnergeyChart =false;
                    setTimeout(() => {
                        this.loadConsumedEnergeyChart =true;
                        this.noDataForEnergy= false;
                        this.loadChargerStausChart = false;
                    }, 500)
                    
                }
                
                
            } catch(er) {
                alert(er)
            }
            
            
        },
        async clearFields() {
            this.loadChargerStausChart = false;
            this.loadConsumedEnergeyChart = false;
            this.noStationAssociatedInd = true;
            this.noDataForEnergy = false;
            try {
                if(this.chartName == 'Charger Status' ) {
                    this.branchId = null;
                    this.displayInd = false;
                    // document.getElementById("branchId").value = null;
                    // this.branchId = '';
                    // localStorage.removeItem('branchInfoForDashboard');
                    localStorage.removeItem("branchIDFromDashboard");
                    this.chargerStatusData = await userData.dashboard.chargerStatus;
                    if(this.chargerStatusData.displayData.totalCount > 0) {
                        this.displayChargerStatus = true;
                        this.displayInd = true;
                        this.loadChargerStausChart = true;
                    } else {
                        this.noStationAssociatedInd = false;
                    }
                } else if(this.chartName == 'Admin Dashboard') {
                    localStorage.removeItem('branchInfoForDashboard');
                    // this.branchId = null;
                    // document.getElementById("branchId").value = null;
                    // this.branchId = '';
                    this.greenHousGasData = await userData.dashboard.energyconsumed;
                    if(this.greenHousGasData) {
                        this.displayFenfeoAdminChart = true;
                        this.loadConsumedEnergeyChart =true;
                        this.displayInd = true;
                    } 
                }
            } catch(error) {
                alert(error)
                // new ToastUtils().presentToast(error.response.data.errors[0].detail);
            }
        
        },

        async searchBranches() {
            localStorage.setItem('fromAdminDashboard', 'Y');
            localStorage.setItem('dashboardType', this.chartName);
            // this.$router.push({name: "branchCPO", params: { branchId: this.branchId }});
        }
    },
})
</script>

<style scoped>
.carterEnergyDashboard {
    overflow: scroll !important;
}
.available {
  color: green;
}
.unavailable {
  color: red;
}
.charging {
  color: orange;
}
.thirdparty {
  color: #26285a;
}
.total {
  color: rgb(159, 21, 223);
}
.status-info {
  padding: 15px;
  margin-top: 35px;
  margin-right: 35px;
  /* text-align: center; */
  border: 3px solid grey;
  border-radius: 10px;
  box-shadow: 3px 3px grey;
}
.noStations {
  margin-top: -140px;
  font-weight: bold;
}
.noStations1 {
  font-weight: bold;
}
.noAssociatedStations {
    
  /* margin-top: -440px; */
  font-weight: bold;
}
.l-c1, .l-c2, .l-c3, .l-c4 {
  border: 1px solid lightgrey;
  margin: 2px;
  background: #ebebeb;
}
.btn-refresh {
  text-align: center !important;
  margin-left: 40px;
    font-family: "Roboto";
    font-size: 1.5rem;
    letter-spacing: 0;
    color: #ffffff;
    height: 40px;
    --background: #e1899c 0% 0% no-repeat padding-box;
    --background-focused: #b4b2b2 !important;
    --background-hover: #b4b2b2 !important;
    --webkit-background-focused: #b4b2b2 !important;
    --webkit-background-hover: #b4b2b2 !important;
    border-radius: 3px;
    opacity: 1;
    /* bottom: 0; */

}
.barChart1 {
  height: 370px !important;
}
.chart-label {
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
}
.my-chart {
    width: 450px !important;
    height: 450px !important;
}
.rectangle-dump {
  
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  padding: 1px;
  opacity: 1;
}
.rectangle-dump1 {
  
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  padding: 1px;
  opacity: 1;
}
.display-value {
  text-align: left;
  padding: 0;
  margin: 0;
  font-weight: bold;
}
@media screen and (max-width: 360px) {
    .my-chart {
        width: 350px !important;
        height: 350px !important;
    }
    .status-info {
        padding: 15px;
        margin-top: 35px;
        margin-right: 3px;
        text-align: center;
    }
}
</style>